var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable import/no-deprecated */
import React, { useContext, useEffect, useLayoutEffect, useMemo } from 'react';
import { createGlobalStyle, ThemeProvider as SCThemeProvider, useTheme } from 'styled-components';
import { cookbookReactContext } from '@creditornot/cb-context';
import { createThemedCssVarDefinitions, themedConfigToThemedAttrs } from './cssUtils';
import semanticColors from './semanticColors';
var useIsomorphicLayoutEffect = typeof window === 'object' ? useLayoutEffect : useEffect;
/** @deprecated */
var CSS_SEMANTIC_VARIABLE_PROPERTY = 'cookbook-colors';
var CSS_SEMANTIC_VARIABLE_PROPERTY_NEW = 'cb-color';
var createCssVarDefinitions = function (keyPrefix) {
    return createThemedCssVarDefinitions('', Object.fromEntries(Object.entries(themedConfigToThemedAttrs(semanticColors)).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        return [
            "".concat(keyPrefix, "-").concat(key),
            val,
        ];
    })));
};
var GlobalThemeStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* old CSS vars prefix key that will be removed in the future */\n  ", "\n\n  /* To add forward-looking compatibility for ingredients@v3 */\n  ", "\n"], ["\n  /* old CSS vars prefix key that will be removed in the future */\n  ", "\n\n  /* To add forward-looking compatibility for ingredients@v3 */\n  ", "\n"])), createCssVarDefinitions(CSS_SEMANTIC_VARIABLE_PROPERTY), createCssVarDefinitions(CSS_SEMANTIC_VARIABLE_PROPERTY_NEW));
var theme = { __isUsingCookbookProvider: true };
/**
 * @deprecated Migrate to `cb-ingredients@3` and the `useThemeMode` from `cb-provider`.
 * See the [migration guide](https://github.com/creditornot/wolt-cookbook/blob/master/packages/ingredients/docs/2-to-3-migration-guide.md) for more information.
 */
export var useThemeMode = function () {
    var _a;
    var cookbookContext = useContext(cookbookReactContext);
    var theme = useTheme();
    if (cookbookContext) {
        return cookbookContext.themeMode;
    }
    return (_a = theme === null || theme === void 0 ? void 0 : theme.cbThemeMode) !== null && _a !== void 0 ? _a : 'light';
};
/**
 * @deprecated Migrate to `cb-ingredients@3` and the `useDirection` from `cb-provider`.
 * See the [migration guide](https://github.com/creditornot/wolt-cookbook/blob/master/packages/ingredients/docs/2-to-3-migration-guide.md) for more information.
 */
export var useDirection = function () {
    var _a;
    var cookbookContext = useContext(cookbookReactContext);
    var theme = useTheme();
    if (cookbookContext) {
        return cookbookContext.direction;
    }
    return (_a = theme === null || theme === void 0 ? void 0 : theme.cbDirection) !== null && _a !== void 0 ? _a : 'ltr';
};
/**
 * @deprecated Migrate to `cb-ingredients@3` and the `CookbookProvider` from `cb-provider`.
 * See the [migration guide](https://github.com/creditornot/wolt-cookbook/blob/master/packages/ingredients/docs/2-to-3-migration-guide.md) for more information.
 */
export var CookbookProvider = function (_a) {
    var children = _a.children, _b = _a.direction, direction = _b === void 0 ? 'ltr' : _b, _c = _a.themeMode, themeMode = _c === void 0 ? 'light' : _c;
    useIsomorphicLayoutEffect(function () {
        document.documentElement.setAttribute('data-cb-theme', themeMode);
        document.body.setAttribute('data-cb-theme', themeMode); // legacy, should be removed in a breaking change
    }, [themeMode]);
    useIsomorphicLayoutEffect(function () {
        document.documentElement.setAttribute('dir', direction);
    }, [direction]);
    var contextValue = useMemo(function () { return ({
        direction: direction,
        themeMode: themeMode,
    }); }, [direction, themeMode]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalThemeStyles, null),
        React.createElement(cookbookReactContext.Provider, { value: contextValue },
            React.createElement(SCThemeProvider, { theme: theme }, children))));
};
export var cbSemanticCssVars = Object.fromEntries(Object.keys(semanticColors.light).map(function (key) { return [
    key,
    "var(--".concat(CSS_SEMANTIC_VARIABLE_PROPERTY, "-").concat(key, ")"),
]; }));
/**
 * Trims extraWhiteSpace
 * ` a b      c` => ` a b c`
 */
var trimWhiteSpace = function (str) { return str.replace(/\s+/g, ' '); };
export function cssThemedValue(value) {
    return function (context) {
        var cbThemeMode = context === null || context === void 0 ? void 0 : context.theme.cbThemeMode;
        var isUsingCookbookProvider = !!(context === null || context === void 0 ? void 0 : context.theme.__isUsingCookbookProvider);
        if (isUsingCookbookProvider && typeof value === 'object' && cbThemeMode === undefined) {
            throw new Error(trimWhiteSpace("You're using CookbookProvider, but also using cssThemedValue with a themed object.\n         You also need to manually define cbThemeMode in styled-components theme in order for this to work."));
        }
        if (typeof value === 'string') {
            return isUsingCookbookProvider
                ? cbSemanticCssVars[value]
                : semanticColors[cbThemeMode !== null && cbThemeMode !== void 0 ? cbThemeMode : 'light'][value];
        }
        return value[cbThemeMode !== null && cbThemeMode !== void 0 ? cbThemeMode : 'light'];
    };
}
var templateObject_1;
//# sourceMappingURL=CookbookProvider.js.map